/* ============================================================
   Apolnus — 政策頁「聯絡資訊」前端微調(只在政策頁載入,可逆,不動後台內容)
   1) 在「公式LINE」區塊插入綠色 LINE 按鈕(不依賴後台 QR 圖;若有殘留 QR 會移除)。
   2) 把 support email 那個指向後台(coowo.com)的錯誤連結改成純文字。
   ※ QR 圖另由 policy-custom.css 以 display:none 即時隱藏,避免載入瞬間閃一下。
   ============================================================ */
(function () {
  var LINE_URL = 'https://line.me/R/ti/p/@apolnus.jp';

  function lineButton() {
    var a = document.createElement('a');
    a.href = LINE_URL; a.target = '_blank'; a.rel = 'noopener'; a.className = 'policy-line-btn';
    a.innerHTML =
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">' +
      '<path d="M12 2C6.48 2 2 5.64 2 10.12c0 4.01 3.55 7.37 8.35 8 .32.07.77.21.88.48.1.25.07.63.03.88l-.14.85c-.04.25-.2.99.86.54 1.07-.45 5.74-3.38 7.83-5.79C21.2 13.4 22 11.86 22 10.12 22 5.64 17.52 2 12 2z"/>' +
      '</svg><span>LINEで友だち追加</span>';
    return a;
  }

  function addLineButton() {
    var body = document.querySelector('.shopify-policy__body');
    if (!body) return;
    if (body.querySelector('.policy-line-btn')) return; // 已有按鈕,不重複

    // 若仍殘留 QR 圖,移除(避免重複出現)
    var qr = body.querySelector('img[src*="LINE2" i], img[src*="line2" i]');
    if (qr) { var w = qr.closest('a'); (w && w.textContent.trim() === '' ? w : qr).remove(); }

    // 把按鈕插在「@apolnus.jp 文字結束之後」(與第一版一致)
    var anchor = null;
    // 優先:含 @apolnus.jp 的文字區塊(Oxygen 的 .ct-text-block,內含 <br> 也算)
    var tbs = body.querySelectorAll('.ct-text-block');
    for (var i = 0; i < tbs.length; i++) {
      if (tbs[i].textContent.indexOf('@apolnus.jp') !== -1) { anchor = tbs[i]; break; }
    }
    // 退而求其次:含 @apolnus.jp 且沒有非 <br> 子元素的最內層元素
    if (!anchor) {
      var all = body.querySelectorAll('p, div, span');
      for (var k = 0; k < all.length; k++) {
        var hasElemChild = false, ch = all[k].children;
        for (var c = 0; c < ch.length; c++) { if (ch[c].tagName !== 'BR') { hasElemChild = true; break; } }
        if (!hasElemChild && all[k].textContent.indexOf('@apolnus.jp') !== -1) { anchor = all[k]; break; }
      }
    }
    // 最後手段:公式LINE 標題後
    if (!anchor) {
      var hs = body.querySelectorAll('.ct-headline, h2, h3');
      for (var j = 0; j < hs.length; j++) { if (hs[j].textContent.indexOf('LINE') !== -1) { anchor = hs[j]; break; } }
    }
    if (!anchor) return;
    if (anchor.classList && anchor.classList.contains('ct-text-block')) {
      // 移除尾端空白換行,然後把按鈕直接放進區塊內(緊貼 @apolnus.jp 正下方)
      var last = anchor.lastChild;
      while (last && (last.nodeName === 'BR' || (last.nodeType === 3 && last.textContent.trim() === ''))) {
        var prev = last.previousSibling; anchor.removeChild(last); last = prev;
      }
      anchor.appendChild(lineButton());
    } else {
      anchor.insertAdjacentElement('afterend', lineButton());
    }
  }

  /* email 連到後台(coowo.com / email-address)的錯誤連結 → 改成純文字 */
  function fixBadEmailLink() {
    document.querySelectorAll('.shopify-policy__body a[href*="coowo"], .shopify-policy__body a[href*="email-address"]').forEach(function (a) {
      a.parentNode.replaceChild(document.createTextNode(a.textContent), a);
    });
  }

  function run() { addLineButton(); fixBadEmailLink(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
